import { Just, Maybe, Nothing } from "purify-ts";
import { useMemo } from "react";

export const mightBeNull = <T>(value?: T | null): Maybe<T> =>
  value === null || value === undefined ? Nothing : Just(value);

export const mightBeEmpty = <T>(value?: T | null): Maybe<T> =>
  mightBeNull(value).isNothing() ||
  (typeof value === "string" && value === "") ||
  (Array.isArray(value) && value.length === 0)
    ? Nothing
    : Just(value as T);

export const useButMightBeEmpty = <T>(
  value?: T | null | undefined,
): Maybe<T> => {
  return useMemo(() => mightBeEmpty(value), [value]);
};
